import { createSlice } from '@reduxjs/toolkit';
export const visibilitySlice = createSlice({
    name: '@@VISIBILITY',
    initialState: {},
    reducers: (create)=>({
            update: create.reducer((_state, { payload: visibility })=>visibility)
        })
});
